import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const PREMIUM_EVENT = "dietflix:premium-required";

// Any 402 anywhere in the app opens the global upgrade dialog instead of a dead-end alert.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 402) {
      err.isPremium = true;
      const feature = err.response?.data?.feature || err.response?.data?.detail;
      window.dispatchEvent(new CustomEvent(PREMIUM_EVENT, { detail: { feature } }));
    }
    return Promise.reject(err);
  }
);

// Use in catch blocks: shows a normal error toast, but stays silent on 402
// (the global upgrade dialog is shown instead).
export function showApiError(err) {
  if (err?.isPremium || err?.response?.status === 402) return;
  toast.error(formatApiError(err?.response?.data?.detail));
}

export default api;
